module.exports = __webpack_public_path__ + "img/nt54-03-80-1.prt.17fe9d3a.jpg";